export default __webpack_public_path__ + "static/media/booking-app-pic2.f574638d.png";